import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormModule } from '@woolworthsnz/form';
import { StyleguideModule } from '@woolworthsnz/styleguide';
import {
	AddToTrolleyComponent,
	AllowSubstitutesComponent,
	BonusProductComponent,
	BrandSuggestionComponent,
	CarouselElementComponent,
	ChangedPriceModalComponent,
	ContentInGridComponent,
	EachKgSelectorComponent,
	FuelTagComponent,
	GridComponent,
	ListHeaderComponent,
	PriceComponent,
	PriceMetaComponent,
	PriceMetaV2Component,
	PriceSingleUnitAverageComponent,
	ProductImageComponent,
	QuantitySelectorComponent,
	SampleListComponent,
	SeoComponent,
	ShopperNotesComponent,
	StampComponent,
	StampGridComponent,
	StampListComponent,
	TagComponent,
} from './components';
import { CitrusAdService, ListService, ProductService, SpaNavigationService } from './services';

const components = [
	AddToTrolleyComponent,
	AllowSubstitutesComponent,
	BonusProductComponent,
	CarouselElementComponent,
	FuelTagComponent,
	EachKgSelectorComponent,
	GridComponent,
	ListHeaderComponent,
	PriceComponent,
	PriceMetaComponent,
	PriceMetaV2Component,
	ProductImageComponent,
	QuantitySelectorComponent,
	SampleListComponent,
	SeoComponent,
	ShopperNotesComponent,
	StampComponent,
	StampGridComponent,
	StampListComponent,
	TagComponent,
	PriceSingleUnitAverageComponent,
	ContentInGridComponent,
	BrandSuggestionComponent,
	ChangedPriceModalComponent,
];

@NgModule({
	exports: [...components],
	imports: [
		CommonModule,
		FormModule,
		OverlayModule,
		PortalModule,
		ReactiveFormsModule,
		RouterModule,
		StyleguideModule,
		...components,
	],
})
export class ProductModule {
	static forRoot(): ModuleWithProviders<ProductModule> {
		return {
			ngModule: ProductModule,
			providers: [ProductService, ListService, CitrusAdService, CurrencyPipe, SpaNavigationService],
		};
	}
}
